// Mocked data for FileInfo and Order types

import type { FileInfoServer } from '../../../types/File';
import type { Order } from '../../../types/Order';

const mockedFilesUser1: FileInfoServer[] = [
  {
    id: 1,
    name: 'file1_user1.stl',
    size: 1024,
    status: 'done',
    created_at: '2023-07-01T10:00:00Z',
  },
  {
    id: 2,
    name: 'file2_user1.stl',
    size: 2048,
    status: 'processing',
    created_at: '2023-07-02T11:00:00Z',
  },
];

const mockedFilesUser2: FileInfoServer[] = [
  {
    id: 3,
    name: 'file1_user2.stl',
    size: 1024,
    status: 'done',
    created_at: '2023-07-01T10:00:00Z',
  },
  {
    id: 4,
    name: 'file2_user2.stl',
    size: 2048,
    status: 'processing',
    created_at: '2023-07-02T11:00:00Z',
  },
];

const mockedFilesUser3: FileInfoServer[] = [
  {
    id: 5,
    name: 'file1_user3.stl',
    size: 1024,
    status: 'done',
    created_at: '2023-07-01T10:00:00Z',
  },
  {
    id: 6,
    name: 'file2_user3.stl',
    size: 2048,
    status: 'processing',
    created_at: '2023-07-02T11:00:00Z',
  },
];

export const mockedOrders: Order[] = [
  {
    id: 1,
    user_id: 1,
    created_at: new Date('2023-07-10T10:00:00Z'),
    status: 'pending',
    machine_type: '3d',
    number_parts: 10,
    material_id: 5,
    color: 'red',
    type: 'fullcontour',
    delivery_time: new Date('2023-07-20T10:00:00Z'),
    modeling: true,
    price: 100.0,
    pickup: 'fromShop',
    address: {
      name: 'Alice Admin',
      phone: '123-456-7890',
      city: 'Варна',
      address: 'Admin Address, Варна',
      note: 'Leave at the door',
    },
    files: mockedFilesUser1.map(file => ({ ...file, created_at: new Date(file.created_at) })),
    comment: 'Urgent order',
  },
  {
    id: 2,
    user_id: 2,
    created_at: new Date('2023-07-11T11:00:00Z'),
    status: 'shipped',
    machine_type: 'milling',
    number_parts: 20,
    material_id: 3,
    color: 'blue',
    type: 'coping',
    delivery_time: new Date('2023-07-21T11:00:00Z'),
    modeling: false,
    price: 200.0,
    pickup: 'ourCourier',
    address: {
      name: 'Bob Moderator',
      phone: '987-654-3210',
      city: 'Варна',
      address: 'Moderator Address, Варна',
      note: 'Deliver to security',
    },
    files: mockedFilesUser2.map(file => ({ ...file, created_at: new Date(file.created_at) })),
    comment: 'Handle with care',
  },
  {
    id: 3,
    user_id: 3,
    created_at: new Date('2023-07-12T12:00:00Z'),
    status: 'finished',
    machine_type: '3d',
    number_parts: 5,
    material_id: 1,
    color: 'green',
    type: 'fullcontour',
    delivery_time: new Date('2023-07-22T12:00:00Z'),
    modeling: true,
    price: 150.0,
    pickup: 'address',
    address: {
      name: 'Charlie User',
      phone: '555-123-4567',
      city: 'Варна',
      address: 'User Address, Варна',
      note: 'Front desk',
    },
    files: mockedFilesUser3.map(file => ({ ...file, created_at: new Date(file.created_at) })),
    comment: 'Standard order',
  },
];
